import React from 'react';

const VIEWS = [
  { id: 'dotplot', label: 'Dot Plot' },
  { id: 'strip', label: 'Strip Plot' },
  { id: 'volcano', label: 'Volcano' },
  { id: 'mutations', label: 'Mutations' },
  { id: 'transformation', label: 'EZH2i' },
  { id: 'gene', label: 'Gene Search' },
  { id: 'report', label: 'Report' },
];

export default function ViewTabs({ activeView, onChangeView }) {
  return (
    <div className="view-tabs">
      {VIEWS.map(v => (
        <button
          key={v.id}
          className={activeView === v.id ? 'active' : ''}
          onClick={() => onChangeView(v.id)}
        >
          {v.label}
        </button>
      ))}
    </div>
  );
}
